import React from "react";
import { Link } from "react-router-dom";

const BlogCard = ({ post }) => {
  return (
    <div className="blog-card2">
      <img src={post.image} alt={post.title} />
      <h3>{post.title}</h3>
      <p>{post.excerpt}</p>
      <Link to={post.link} >
        <button className="read-more-btn2">Read More</button>
      </Link>
    </div>
  );
};

export default BlogCard;
